// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5":"deb4b2f4","323":"31248857","437":"d141bf74","490":"31248857","749":"b94d6844","827":"d69f83ad"}[chunkId] + ".chunk.css";
};